// src/utils/privacy.ts
export const maskSensitiveData = (element: HTMLElement): void => {
  // Add data attributes to sensitive elements
  const sensitiveSelectors = [
    '[type="password"]',
    '[data-sensitive="true"]',
    '.credit-card',
    '.ssn',
    '.personal-data'
  ];

  sensitiveSelectors.forEach(selector => {
    const elements = element.querySelectorAll(selector);
    elements.forEach(el => {
      el.setAttribute('data-mp-mask', 'true');
    });
  });
};

export const initializePrivacyProtection = (): void => {
  // This should be called when your app loads
  if (typeof window !== 'undefined') {
    // Mask existing elements
    maskSensitiveData(document.body);

    // Observe DOM changes for dynamically added content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // ELEMENT_NODE
            maskSensitiveData(node as HTMLElement);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};